export default __webpack_public_path__ + "static/media/fe6cc71e770e2c6e.a58797ed0f59bbdf36d9c3c8ba1599b1.svg";